import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const smallClassNursery: BlogMetaData = {
  title: '少人数の保育園のメリット・デメリットは？小規模保育との違いと3歳の壁',
  description:
    '少人数の保育園は本当に良い？「少人数保育園」と制度上の「小規模保育事業」の違い、メリット・デメリット、大規模園との環境差、3歳の壁の意味、見学で見るポイントを、少人数の園を運営する園長が整理します。',
  thumbnailUrl: '/img/blog-small-class-nursery.webp',
  filePath: buildBlogFilePath('small-class-nursery'),
  category: BLOG_CATEGORY.NURSERY,
};
